import $ from "jquery";

// Set jQuery globally before importing DataTables
window.$ = window.jQuery = $;

const vendorHelper = {
  async initDataTables() {
    // Dynamically import DataTables to ensure jQuery is available
    await import("datatables.net");
    await import("datatables.net-bs5");
    await import("datatables.net-responsive");
    await import("datatables.net-responsive-bs5");

    // Configure DataTables defaults
    $.extend($.fn.dataTable.defaults, {
      dom: "t",
      retrieve: true,
      ordering: false,
      lengthMenu: [
        [15, 25, 50, 100],
        [15, 25, 50, 100],
      ],
      pageLength: 15,
      pagingType: "simple_numbers",
      responsive: true,
      columnDefs: [
        { responsivePriority: 1, targets: 0 },
        { responsivePriority: 2, targets: -1 },
        { responsivePriority: 3, targets: -2 },
      ],
      stateSave: true,
    });
  },
};

export default vendorHelper;
